var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2083 4.14995L8.04167 2.69162C7.69167 2.56662 7.30833 2.56662 6.95833 2.68329L3.63333 3.79995C2.95833 4.03329 2.5 4.66662 2.5 5.38329V15.2583C2.5 16.4333 3.675 17.2333 4.76667 16.8083L7.20833 15.8583C7.39167 15.7833 7.6 15.7833 7.78333 15.85L11.95 17.3083C12.3 17.4333 12.6833 17.4333 13.0333 17.3166L16.3583 16.2C17.0333 15.975 17.4917 15.3333 17.4917 14.6166V4.74162C17.4917 3.56662 16.3167 2.76662 15.225 3.19162L12.7833 4.14162C12.6 4.20829 12.4 4.21662 12.2083 4.14995ZM12.5 15.7416L7.5 13.9833V4.25829L12.5 6.01662V15.7416Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "domtour/theme/workation/music/media/map.da6c93b77b9fd08d917e1081db29c190.svg";
export { ForwardRef as ReactComponent };